import { BeginOrEndOfSeaPassage } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const BEGIN_OR_END_OF_SEA_PASSAGE_DATA_TAG = 'BeginOrEndOfSeaPassage';
export default class BeginOrEndOfSeaPassageParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.AT_SEA_BEGIN_OR_END_OF_SEA_PASSAGE, FIXED_PROTOCOL_CONTENT_TYPE_IDS.AT_SEA_BEGIN_OR_END_OF_SEA_PASSAGE, BEGIN_OR_END_OF_SEA_PASSAGE_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            bospEosp: 'bospEosp',
            freeText: 'freeText',
            distanceSinceDepartureBosp: 'distanceSinceDepartureBosp',
        };
    }
    createData(props) {
        return new BeginOrEndOfSeaPassage(props.bospEosp, props.distanceSinceDepartureBosp, props.freeText);
    }
}
//# sourceMappingURL=BeginOrEndOfSeaPassageParser.js.map